function filterMarker(thisText) {
  // Filter markers present in the country/state or continent
  return mapMarkers.filter(el => {
    const continent = el.continent.toLowerCase();
    const stateCountry = el.state_country.toLowerCase();
    return continent == thisText || stateCountry == thisText;
  });
}

function fitAllMarkers(map, filteredLocationMarkers) {
  let bounds = new google.maps.LatLngBounds();
  if (filteredLocationMarkers.length) {
    filteredLocationMarkers.map(item => {
      bounds.extend(item.location);
    });
    map.fitBounds(bounds);
  }
}

module.exports = {
  filterMarker,
  fitAllMarkers
}



// WEBPACK FOOTER //
// ../assets/js/map/filter-markers.js